import React from "react";
import Chart from "react-apexcharts";
import { FiRefreshCw } from "react-icons/fi";

const ReimbursementCard = () => {
  const data = [10, 20, 30, 40, 50, 60, 50, 40, 30, 20, 10];

  return (
    <div className=" d-flex h-100">
      <div className="card custom-card">
        <div className="card-body">

          {/* TOP */}
          <div className="top">
            <div className="icon-box">
              <img
                src="/assets/img/icons/title-icon-03.svg"
                className="icon"
                alt=""
              />
              <img
                src="/assets/img/bg/title-bg-03.png"
                className="bg-icon"
                alt=""
              />
            </div>

            <button className="refresh-btn">
              <FiRefreshCw />
            </button>
          </div>

          {/* TITLE */}
          <div className="content">
            <p>Reimbrusement</p>

            <h2>
              $124,200
              <span className="down-badge">▼</span>
            </h2>
          </div>

          {/* GRAPH */}
          <div className="chart">
          <Chart
  options={{
    chart: {
      type: "bar",
      sparkline: { enabled: true },
      toolbar: { show: false },
    },

    plotOptions: {
      bar: {
        columnWidth: "14%", // 🔥 thin but visible (exact like image)
        borderRadius: 2,
        distributed: true,
      },
    },

    // 🔥 EXACT COLOR PATTERN (LEFT STRONG → RIGHT FADE)
    colors: [
      "#6b8f99","#6b8f99","#6b8f99","#6b8f99","#6b8f99",
      "#6b8f99","#6b8f99","#6b8f99","#6b8f99","#6b8f99",
      "#6b8f99","#6b8f99","#6b8f99","#6b8f99","#6b8f99",
      "#6b8f99","#6b8f99","#6b8f99","#6b8f99","#6b8f99",
      "#9fb3b9","#c7d3d8","#e5e7eb","#f1f5f9","#f8fafc","#f8fafc"
    ],

    tooltip: {
      enabled: true,
      intersect: true,
      custom: function () {
        return `
          <div class="custom-tooltip">
            <div class="tt-title">Total</div>
            <div class="tt-body">
              <span class="dot"></span>
              Remaining: <b>600</b>
            </div>
          </div>
        `;
      },
    },

    xaxis: {
      categories: Array.from({ length: 25 }, (_, i) => i + 1),
      labels: { show: false },
    },

    yaxis: { show: false },
    grid: { show: false },
  }}

  series={[
    {
      data: [
        55,55,55,55,55,55,55,55,55,55,
        55,55,55,55,55,
       55,55,55,55,55,55,55,55,55,55,
      ],
    },
  ]}

  type="bar"
  height={110}
/>
          </div>

        </div>

        {/* BACKGROUND */}
        <img
          src="/assets/img/bg/attendance-bg.png"
          className="card-bg"
          alt=""
        />

        {/* CSS */}
        <style>{`
          .custom-card {
            border-radius: 12px;
            overflow: hidden;
            position: relative;
            width: 100%;
          }

          .card-body {
            position: relative;
            z-index: 2;
          }

          /* TOP */
          .top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
          }

          .icon-box {
            position: relative;
            width: 45px;
            height: 45px;
          }

          .icon {
            width: 28px;
            position: relative;
            z-index: 2;
          }

          .bg-icon {
            position: absolute;
            width: 45px;
            top: 0;
            left: 0;
            opacity: 0.2;
          }

          /* REFRESH BUTTON */
          .refresh-btn {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            border: 1px solid #e5e7eb;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          /* CONTENT */
          .content p {
            font-size: 14px;
            color: #6b7280;
            margin-bottom: 4px;
          }

          .content h2 {
            font-size: 26px;
            font-weight: 700;
            display: flex;
            align-items: center;
            gap: 8px;
          }

          /* 🔴 DOWN BADGE */
          .down-badge {
            background: #ef4444;
            color: #fff;
            font-size: 12px;
            border-radius: 50%;
            padding: 4px 6px;
          }

          /* CHART */
          .chart {
            margin-top: 10px;
          }

          /* TOOLTIP */
          .custom-tooltip {
            background: #fff;
            padding: 10px;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.1);
          }

          .tt-title {
            font-size: 13px;
            margin-bottom: 5px;
          }

          .tt-body {
            font-size: 13px;
            display: flex;
            align-items: center;
            gap: 6px;
          }

          .dot {
            width: 8px;
            height: 8px;
            background: #cbd5e1;
            border-radius: 50%;
          }

          /* BACKGROUND IMAGE */
          .card-bg {
            position: absolute;
            top: 0;
            width: 100%;
            opacity: 0.2;
            z-index: 1;
          }

          /* MOBILE */
          @media (max-width: 768px) {
            .content h2 {
              font-size: 22px;
            }
          }
        `}</style>
      </div>
    </div>
  );
};

export default ReimbursementCard;